module.exports = __webpack_public_path__ + "static/Zam@2x.4aa61082.png";